module.exports = __webpack_public_path__ + "static/img/9.9233d23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/zh/9.png
// module id = c3WV
// module chunks = 0